import script from "./ScreenSlideList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenSlideList.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenSlideList.vue?vue&type=style&index=0&id=77a3e620&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a3e620"]])

export default __exports__